module.exports = "/work-site/img/warm_type.f354ca01.png";